// Smart Daara - i18n Configuration
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import fr from './locales/fr.json';
import en from './locales/en.json';

// Get saved language or default to French
const savedLanguage = localStorage.getItem('smart-daara-language') || 'fr';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en }
    },
    lng: savedLanguage,
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false // React already handles XSS
    },
    // Namespace configuration
    defaultNS: 'translation',
    ns: ['translation'],
    // Debug mode in development
    debug: process.env.NODE_ENV === 'development'
  });

// Save language preference when changed
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('smart-daara-language', lng);
  document.documentElement.lang = lng;
});

export default i18n;
